import axios from 'axios'

import { handleRequestError } from './request'

export const RECEIVE_COUNTRIES = 'RECEIVE_COUNTRIES'
export const REQUEST_COUNTRIES = 'REQUEST_COUNTRIES'

export const requestCountries = () => (dispatch) => {
    dispatch({ type: REQUEST_COUNTRIES })

    axios
        .get('/countries')
        .then((response) => {
            const items = response?.data || []
            dispatch(receiveCountries({ items, fetchSuccessful: true }))
        })
        .catch((error) => {
            dispatch(receiveCountries({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveCountries = (data) => (dispatch) => {
    dispatch({ type: RECEIVE_COUNTRIES, data })
}
